<script>
import Layout from "@layouts/form";
import GrupoItens from "@components/GrupoItens";
import api from "@services/api";
export default {
  props: {
    name: {
      type: String,
      default: "Grupo"
    },
    table: {
      type: String,
      default: ""
    },
    fields: {
      type: Array,
      default: () => {
        return [];
      }
    },
    filter: {
      type: String,
      default: ""
    },
    include: {
      type: String,
      default: ""
    },
    showBtnNew: {
      type: Boolean,
      default: true
    },
    tooltip: {
      type: Boolean,
      default: false
    }
  },
  components: { Layout, GrupoItens },
  data() {
    return {
      title: this.name,
      items: [
        {
          text: "Admin",
          href: "#"
        },
        {
          text: "Permissões",
          href: "#",
          active: true
        },
        {
          text: "Usuario",
          href: "#",
          active: true
        }
      ],
      nomeGrupo: ""
    };
  },
  methods: {
    GetNomeGrupo() {
      api
        .get("crud/Grupo/getNomeGrupo", {
          params: {
            grupoId: this.$route.params.id
          }
        })
        .then(response => {
          this.nomeGrupo = response.data["data"];
          this.items = [
            { text: "Permissões", href: "/grupo" },
            { text: this.nomeGrupo, href: "#", active: true }
          ];
        });
    }
  },
  created() {
    this.GetNomeGrupo();
  }
};
</script>

<template>
  <Layout
    :title="title"
    :items="items"
    :alertVisible="false"
    :camposObgVisible="false"
  >
    <div class="page-content">
      <GrupoItens></GrupoItens>
    </div>
  </Layout>
</template>
